/* eslint-disable */
import * as Types from '../../graphql/types.generated';

import { gql } from '@apollo/client';
import { AgentCardFragmentDoc } from './agentCard.generated';
import { AgentFiltersFragmentDoc } from './agentFilters.generated';
import { ReviewAggregationCollectionFragmentDoc } from '../../lib/reviewAggregation.generated';
import * as Apollo from '@apollo/client';
import type React from 'react';
import { getApolloClient } from 'lib/apollo';
const defaultOptions = {} as const;
export type AgentsListQueryVariables = Types.Exact<{
  filters?: Types.InputMaybe<Types.AgentFilter>;
}>;


export type AgentsListQuery = { __typename?: 'Query', agentCollection?: { __typename?: 'AgentCollection', items: Array<{ __typename?: 'Agent', calendlyUrl?: string | null, calendlyUrlFullCalendarOverride?: string | null, active?: boolean | null, name?: string | null, slug?: string | null, licensedYear?: number | null, city?: string | null, county?: string | null, phoneNumber?: string | null, businessCardUrl?: string | null, velocifyId?: number | null, sys: { __typename?: 'Sys', id: string }, photo?: { __typename?: 'Asset', description?: string | null, url?: string | null, width?: number | null, height?: number | null } | null } | null> } | null };

export type AgentsFiltersQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type AgentsFiltersQuery = { __typename?: 'Query', agentCollection?: { __typename?: 'AgentCollection', items: Array<{ __typename?: 'Agent', products?: Array<string | null> | null, insuranceCarrier?: Array<string | null> | null, certifications?: Array<string | null> | null, languages?: Array<string | null> | null, sys: { __typename?: 'Sys', id: string } } | null> } | null };

export type AgentsPageQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type AgentsPageQuery = { __typename?: 'Query', pageCollection?: { __typename?: 'PageCollection', items: Array<{ __typename?: 'Page', seoTitle?: string | null, seoDescription?: string | null, openGraphImage?: { __typename?: 'Asset', url?: string | null } | null } | null> } | null };

export type AgentsReviewsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type AgentsReviewsQuery = { __typename?: 'Query', reviewAggregationCollection?: { __typename?: 'ReviewCollection', total: number, items: Array<{ __typename?: 'Review', starRating?: number | null, agent?: { __typename?: 'Agent', sys: { __typename?: 'Sys', id: string } } | null, sys: { __typename?: 'Sys', id: string } } | null> } | null };


export const AgentsListDocument = gql`
    query AgentsList($filters: AgentFilter) {
  agentCollection(order: active_DESC, where: $filters) {
    items {
      sys {
        id
      }
      ...AgentCard
      calendlyUrl
      calendlyUrlFullCalendarOverride
      active
    }
  }
}
    ${AgentCardFragmentDoc}`;

/**
 * __useAgentsListQuery__
 *
 * To run a query within a React component, call `useAgentsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useAgentsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAgentsListQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useAgentsListQuery(baseOptions?: Apollo.QueryHookOptions<AgentsListQuery, AgentsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AgentsListQuery, AgentsListQueryVariables>(AgentsListDocument, options);
      }
export function useAgentsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AgentsListQuery, AgentsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AgentsListQuery, AgentsListQueryVariables>(AgentsListDocument, options);
        }
export type AgentsListQueryHookResult = ReturnType<typeof useAgentsListQuery>;
export type AgentsListLazyQueryHookResult = ReturnType<typeof useAgentsListLazyQuery>;
export type AgentsListQueryResult = Apollo.QueryResult<AgentsListQuery, AgentsListQueryVariables>;
export const AgentsFiltersDocument = gql`
    query AgentsFilters {
  agentCollection(order: name_ASC) {
    items {
      sys {
        id
      }
      ...AgentFilters
    }
  }
}
    ${AgentFiltersFragmentDoc}`;

/**
 * __useAgentsFiltersQuery__
 *
 * To run a query within a React component, call `useAgentsFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAgentsFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAgentsFiltersQuery({
 *   variables: {
 *   },
 * });
 */
export function useAgentsFiltersQuery(baseOptions?: Apollo.QueryHookOptions<AgentsFiltersQuery, AgentsFiltersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AgentsFiltersQuery, AgentsFiltersQueryVariables>(AgentsFiltersDocument, options);
      }
export function useAgentsFiltersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AgentsFiltersQuery, AgentsFiltersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AgentsFiltersQuery, AgentsFiltersQueryVariables>(AgentsFiltersDocument, options);
        }
export type AgentsFiltersQueryHookResult = ReturnType<typeof useAgentsFiltersQuery>;
export type AgentsFiltersLazyQueryHookResult = ReturnType<typeof useAgentsFiltersLazyQuery>;
export type AgentsFiltersQueryResult = Apollo.QueryResult<AgentsFiltersQuery, AgentsFiltersQueryVariables>;
export const AgentsPageDocument = gql`
    query AgentsPage {
  pageCollection(where: {slug: "agents"}, limit: 1) {
    items {
      seoTitle
      seoDescription
      openGraphImage {
        url
      }
    }
  }
}
    `;

/**
 * __useAgentsPageQuery__
 *
 * To run a query within a React component, call `useAgentsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useAgentsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAgentsPageQuery({
 *   variables: {
 *   },
 * });
 */
export function useAgentsPageQuery(baseOptions?: Apollo.QueryHookOptions<AgentsPageQuery, AgentsPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AgentsPageQuery, AgentsPageQueryVariables>(AgentsPageDocument, options);
      }
export function useAgentsPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AgentsPageQuery, AgentsPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AgentsPageQuery, AgentsPageQueryVariables>(AgentsPageDocument, options);
        }
export type AgentsPageQueryHookResult = ReturnType<typeof useAgentsPageQuery>;
export type AgentsPageLazyQueryHookResult = ReturnType<typeof useAgentsPageLazyQuery>;
export type AgentsPageQueryResult = Apollo.QueryResult<AgentsPageQuery, AgentsPageQueryVariables>;
export const AgentsReviewsDocument = gql`
    query AgentsReviews {
  reviewAggregationCollection: reviewCollection(order: date_DESC, limit: 5000) {
    ...ReviewAggregationCollection
    items {
      agent {
        sys {
          id
        }
      }
    }
  }
}
    ${ReviewAggregationCollectionFragmentDoc}`;

/**
 * __useAgentsReviewsQuery__
 *
 * To run a query within a React component, call `useAgentsReviewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAgentsReviewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAgentsReviewsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAgentsReviewsQuery(baseOptions?: Apollo.QueryHookOptions<AgentsReviewsQuery, AgentsReviewsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AgentsReviewsQuery, AgentsReviewsQueryVariables>(AgentsReviewsDocument, options);
      }
export function useAgentsReviewsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AgentsReviewsQuery, AgentsReviewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AgentsReviewsQuery, AgentsReviewsQueryVariables>(AgentsReviewsDocument, options);
        }
export type AgentsReviewsQueryHookResult = ReturnType<typeof useAgentsReviewsQuery>;
export type AgentsReviewsLazyQueryHookResult = ReturnType<typeof useAgentsReviewsLazyQuery>;
export type AgentsReviewsQueryResult = Apollo.QueryResult<AgentsReviewsQuery, AgentsReviewsQueryVariables>;
export async function getServerPageAgentsList
    (options: Omit<Apollo.QueryOptions<AgentsListQueryVariables>, 'query'>, ctx?: any ){
        const apolloClient = getApolloClient(ctx);
        
        const data = await apolloClient.query<AgentsListQuery>({ ...options, query: AgentsListDocument });
        
        const apolloState = apolloClient.cache.extract();

        return {
            props: {
                apolloState: apolloState,
                data: data?.data,
                error: data?.error ?? data?.errors ?? null,
            },
        };
      }
export type PageAgentsListComp = React.FC<{data?: AgentsListQuery, error?: Apollo.ApolloError}>;
export const ssrAgentsList = {
      getServerPage: getServerPageAgentsList,
      
      
    }
export async function getServerPageAgentsFilters
    (options: Omit<Apollo.QueryOptions<AgentsFiltersQueryVariables>, 'query'>, ctx?: any ){
        const apolloClient = getApolloClient(ctx);
        
        const data = await apolloClient.query<AgentsFiltersQuery>({ ...options, query: AgentsFiltersDocument });
        
        const apolloState = apolloClient.cache.extract();

        return {
            props: {
                apolloState: apolloState,
                data: data?.data,
                error: data?.error ?? data?.errors ?? null,
            },
        };
      }
export type PageAgentsFiltersComp = React.FC<{data?: AgentsFiltersQuery, error?: Apollo.ApolloError}>;
export const ssrAgentsFilters = {
      getServerPage: getServerPageAgentsFilters,
      
      
    }
export async function getServerPageAgents
    (options: Omit<Apollo.QueryOptions<AgentsPageQueryVariables>, 'query'>, ctx?: any ){
        const apolloClient = getApolloClient(ctx);
        
        const data = await apolloClient.query<AgentsPageQuery>({ ...options, query: AgentsPageDocument });
        
        const apolloState = apolloClient.cache.extract();

        return {
            props: {
                apolloState: apolloState,
                data: data?.data,
                error: data?.error ?? data?.errors ?? null,
            },
        };
      }
export type PageAgentsComp = React.FC<{data?: AgentsPageQuery, error?: Apollo.ApolloError}>;
export const ssrAgents = {
      getServerPage: getServerPageAgents,
      
      
    }
export async function getServerPageAgentsReviews
    (options: Omit<Apollo.QueryOptions<AgentsReviewsQueryVariables>, 'query'>, ctx?: any ){
        const apolloClient = getApolloClient(ctx);
        
        const data = await apolloClient.query<AgentsReviewsQuery>({ ...options, query: AgentsReviewsDocument });
        
        const apolloState = apolloClient.cache.extract();

        return {
            props: {
                apolloState: apolloState,
                data: data?.data,
                error: data?.error ?? data?.errors ?? null,
            },
        };
      }
export type PageAgentsReviewsComp = React.FC<{data?: AgentsReviewsQuery, error?: Apollo.ApolloError}>;
export const ssrAgentsReviews = {
      getServerPage: getServerPageAgentsReviews,
      
      
    }